// Stores
import { useResult } from "../../../shared/formContext/hooks/useResult";

// Result Types
import LoanSavings from "./Result/LoanSavings";
import Error from "@shared/Error/Error";

// Components
import Empty from "@shared/Empty/Empty";
import Loading from "../../../components/Loading/Loading";
import {__} from "@wordpress/i18n";

// UI Messages
const UI_MESSAGES = {
    LOADING: __("A carregar...", "df-simulators"),
    ERROR_STATUS: __("Ocorreu um erro ao carregar os resultados.", "df-simulators"),
    NO_RESULTS: __("Não há resultados disponíveis no momento.", "df-simulators"),
};

const Results = () => {
    const { resultData } = useResult();
    const { response, loading, statusCode } = resultData;

    /**
     * Renders the appropriate result component based on the type and status.
     * @returns {JSX.Element} - Component to be rendered.
     */
    const renderResult = () => {
        // Render loading component if loading and no response yet
        if (loading && !response) {
            return <Loading message={UI_MESSAGES.LOADING}/>;
        }

        // Render empty state if there is no response and no previous result
        if (!response) {
            return <Empty message={UI_MESSAGES.NO_RESULTS}/>;
        }

        // Render error component if there is a status code other than 200
        if (statusCode && statusCode !== 200) {
            console.warn(UI_MESSAGES.ERROR_STATUS);
            return <Error/>;
        }

        return (
            <LoanSavings/>
        );
    };

    return (
        <div className="tool-block__component__results__result">
            {renderResult()}
        </div>
    );
};

export default Results;
